(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5417],{

/***/ 97275:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/self-storage/faq",
      function () {
        return __webpack_require__(54017);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 83664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CanonicalURL; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utility__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55088);




function CanonicalURL() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "canonical",
            href: (0,_utility__WEBPACK_IMPORTED_MODULE_3__/* .getCanonicalURL */ .DN)(router)
        })
    });
}


/***/ }),

/***/ 54017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _components_common_Canonical__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83664);
/* harmony import */ var _components_utility__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55088);
/* harmony import */ var _context_HeaderFooterContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2621);
/* harmony import */ var _services_home_setBrands__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(76784);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(13135);













var AskedQuestions = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4585), __webpack_require__.e(395), __webpack_require__.e(1447)]).then(__webpack_require__.bind(__webpack_require__, 349));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(349)
            ];
        }
    }
});
var FaqsBanner = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1608), __webpack_require__.e(4531)]).then(__webpack_require__.bind(__webpack_require__, 64531));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(64531)
            ];
        }
    }
});
var FAQ = function(props) {
    var ref, ref1;
    var headerFooterData = (0,react__WEBPACK_IMPORTED_MODULE_4__.useContext)(_context_HeaderFooterContext__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP);
    var headerFooter = headerFooterData.headerFooter;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().locale;
    var isContext = !!headerFooter[0];
    var getContextData = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
            var defaultBrand, contextData, brands;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        defaultBrand = _utils_constants__WEBPACK_IMPORTED_MODULE_9__/* .BRAND_NAME_EN */ .Vp;
                        if (locale === "fr") defaultBrand = _utils_constants__WEBPACK_IMPORTED_MODULE_9__/* .BRAND_NAME_FR */ .Fj;
                        return [
                            4,
                            (0,_services_home_setBrands__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(defaultBrand, locale)
                        ];
                    case 1:
                        contextData = _state.sent();
                        brands = contextData === null || contextData === void 0 ? void 0 : contextData.data;
                        headerFooterData.setHeaderFooterData(brands);
                        return [
                            2
                        ];
                }
            });
        });
        return function getContextData() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        getContextData();
    }, [
        isContext,
        locale
    ]);
    var faqData = props.faqData, faqBannerData = props.faqBannerData;
    var faqTitle = faqBannerData === null || faqBannerData === void 0 ? void 0 : (ref = faqBannerData.attributes) === null || ref === void 0 ? void 0 : ref.Title;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var seoProps = (0,_components_utility__WEBPACK_IMPORTED_MODULE_6__/* .getSEOProps */ .RN)(faqBannerData === null || faqBannerData === void 0 ? void 0 : (ref1 = faqBannerData.attributes) === null || ref1 === void 0 ? void 0 : ref1.SEO, router);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "sv-page-content FAQ-wrapper",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_3__/* .NextSeo */ .PB, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, seoProps)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_Canonical__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FaqsBanner, {
                faqBannerData: faqBannerData
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AskedQuestions, {
                faqData: faqData,
                faqTitle: faqTitle,
                hostUrl: props === null || props === void 0 ? void 0 : props.hostUrl
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (FAQ);


/***/ }),

/***/ 66156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Av": function() { return /* binding */ getConvenientLocations; },
/* harmony export */   "YW": function() { return /* binding */ getHeaderAndFooterDetailsWithDefaultLocale; },
/* harmony export */   "Zy": function() { return /* binding */ getRightUnitInfo; },
/* harmony export */   "co": function() { return /* binding */ getVehicleLandingData; },
/* harmony export */   "fC": function() { return /* binding */ getCityLandingInfo; },
/* harmony export */   "fU": function() { return /* binding */ getInnerPagesWithDefaultLocale; },
/* harmony export */   "k5": function() { return /* binding */ getBrandReviews; },
/* harmony export */   "ns": function() { return /* binding */ getGoogleReviews; },
/* harmony export */   "zc": function() { return /* binding */ getOurBrands; }
/* harmony export */ });
/* unused harmony exports getGoogleReview, getHomeBodyDetailsWithDefaultLocale, getStudentSpecialContent, getValidityCity */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var _utils_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15122);
/* harmony import */ var _apiUrl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33891);




var getHeaderAndFooterDetailsWithDefaultLocale = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var brand, locale;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            brand = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "as", locale = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "en";
            return [
                2,
                new Promise(function(resolve, reject) {
                    try {
                        var data = (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getBrandLocaleUrl */ .oo(brand, locale)), "get");
                        resolve(data);
                    } catch (e) {
                        reject(e);
                    }
                })
            ];
        });
    });
    return function getHeaderAndFooterDetailsWithDefaultLocale() {
        return _ref.apply(this, arguments);
    };
}();
var getHomeBodyDetailsWithDefaultLocale = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var brand, locale;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            brand = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "as", locale = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "en";
            return [
                2,
                new Promise(function(resolve, reject) {
                    try {
                        var data = (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getHomeLocaleUrl */ .dK(brand, locale)), "get");
                        resolve(data);
                    } catch (e) {
                        reject(e);
                    }
                })
            ];
        });
    });
    return function getHomeBodyDetailsWithDefaultLocale() {
        return _ref.apply(this, arguments);
    };
}();
var getBrandReviews = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doDataVaultRequest */ .b0)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .GOOGLE_CLIENT_REVIEWS */ .Zk), "get")
            ];
        });
    });
    return function getBrandReviews() {
        return _ref.apply(this, arguments);
    };
}();
var getOurBrands = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .GET_OUR_BRANDS */ .e), "get")
            ];
        });
    });
    return function getOurBrands() {
        return _ref.apply(this, arguments);
    };
}();
// for future lcode include
var getGoogleReviews = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(lcode) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doDataVaultRequest */ .b0)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getClientReviews */ .Vf(lcode)), "get")
            ];
        });
    });
    return function getGoogleReviews(lcode) {
        return _ref.apply(this, arguments);
    };
}();
var getGoogleReview = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(lcode, locale) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doDataVaultRequest */ .b0)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getClientReview */ .tw(lcode, locale)), "get")
            ];
        });
    });
    return function getGoogleReview(lcode, locale) {
        return _ref.apply(this, arguments);
    };
}();
// lat, lng, brand, limit,
var getConvenientLocations = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(lang, cords) {
        var ncards;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            ncards = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 3;
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doDataVaultRequest */ .b0)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .CONVENIENT_LOCATIONS */ .vi, "?lat=").concat(cords === null || cords === void 0 ? void 0 : cords.latitude, "&lng=").concat(cords === null || cords === void 0 ? void 0 : cords.longitude, "&brand=as&limit=").concat(ncards, "&lang=").concat(lang), "get")
            ];
        });
    });
    return function getConvenientLocations(lang, cords) {
        return _ref.apply(this, arguments);
    };
}();
// brand section
var getInnerPagesWithDefaultLocale = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(innerPageName) {
        var brand, locale;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            brand = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "as", locale = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "en";
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getInnerPagesUrl */ .zP(innerPageName, brand, locale)), "get")
            ];
        });
    });
    return function getInnerPagesWithDefaultLocale(innerPageName) {
        return _ref.apply(this, arguments);
    };
}();
// student special content
var getStudentSpecialContent = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(defaultLink, locale, brand) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getStudentSpecialUrl */ .Sh(defaultLink, locale, brand)), "get")
            ];
        });
    });
    return function getStudentSpecialContent(defaultLink, locale, brand) {
        return _ref.apply(this, arguments);
    };
}();
// city landing page
var getCityLandingInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(slug) {
        var brand, locale;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            brand = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "as", locale = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "en";
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getCityLandingInfo */ .fC(slug, brand, locale)), "get")
            ];
        });
    });
    return function getCityLandingInfo(slug) {
        return _ref.apply(this, arguments);
    };
}();
// city landing page
var getVehicleLandingData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(slug) {
        var brand, locale;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            brand = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "as", locale = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "en";
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getVehicleLandingInfo */ .CZ(slug, brand, locale)), "get")
            ];
        });
    });
    return function getVehicleLandingData(slug) {
        return _ref.apply(this, arguments);
    };
}();
// right units
var getRightUnitInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var brand, locale;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            brand = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "as", locale = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "en";
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getRightUnitInfo */ .Zy(brand, locale)), "get")
            ];
        });
    });
    return function getRightUnitInfo() {
        return _ref.apply(this, arguments);
    };
}();
// validate city for facility slug
var getValidityCity = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(slug, brand) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getValidateCity */ .e$(slug, brand)), "get")
            ];
        });
    });
    return function getValidityCity(slug, brand) {
        return _ref.apply(this, arguments);
    };
}();



/***/ }),

/***/ 76784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66156);



var SetBrandsContext = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var brand, locale, ref, result, data;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    brand = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "dp", locale = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "en";
                    return [
                        4,
                        Promise.all([
                            (0,___WEBPACK_IMPORTED_MODULE_0__/* .getHeaderAndFooterDetailsWithDefaultLocale */ .YW)(brand, locale)
                        ])
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        4,
                        (ref = result[0]) === null || ref === void 0 ? void 0 : ref.data
                    ];
                case 2:
                    data = _state.sent() || null;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function SetBrandsContext() {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["Z"] = (SetBrandsContext);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1217,3640,9774,2888,179], function() { return __webpack_exec__(97275); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);